// This file contains a generic ProgressManager which any lab can include,
// if it wants to make progress without reloading the page.
// Abstract class that validates a set of conditions. How
// the validation works is up to the implementor.
var Validator = /** @class */ (function () {
    function Validator() {
    }
    return Validator;
}());
export { Validator };
var ProgressManager = /** @class */ (function () {
    function ProgressManager(progression, validator, onProgressChange) {
        this.progression = progression;
        this.validator = validator;
        this.onProgressChange = onProgressChange;
        this.currentProgressState = {
            step: 0,
            satisfied: false,
            message: null
        };
    }
    ProgressManager.prototype.getProgression = function () {
        return this.progression;
    };
    ProgressManager.prototype.getCurrentState = function () {
        return this.currentProgressState;
    };
    ProgressManager.prototype.getCurrentStepDetails = function () {
        return this.progression.steps[this.currentProgressState.step];
    };
    ProgressManager.prototype.updateProgress = function () {
        var validations = this.progression.steps[this.currentProgressState.step]
            .validations;
        if (!validations) {
            return;
        }
        // Find out from the lab-specific code whether we should be trying to
        // check conditions at the moment.  Otherwise, we might get a fail
        // when we shouldn't have even been checking.
        if (!this.validator.shouldCheckConditions()) {
            return;
        }
        // Give the lab-specific code a chance to check conditions.  We do
        // it once each update in case it's expensive, and since conditions
        // can be used by multiple validations.
        this.validator.checkConditions();
        // Go through each validation to see if we have a match.
        for (var _i = 0, validations_1 = validations; _i < validations_1.length; _i++) {
            var validation = validations_1[_i];
            if (validation.conditions) {
                // Ask the lab-specific validator if this validation's
                // conditions are met.
                if (this.validator.conditionsMet(validation.conditions)) {
                    this.currentProgressState.satisfied = validation.next;
                    this.currentProgressState.message = validation.message;
                    this.onProgressChange();
                    return;
                }
            }
            else {
                this.currentProgressState.message = validation.message;
            }
        }
        this.onProgressChange();
    };
    // Advance to the next step.  Advances the state internally and calls
    // the change handler.
    ProgressManager.prototype.next = function () {
        // Give the lab the chance to clear accumulated satisfied conditions.
        this.validator.clear();
        this.currentProgressState.step++;
        this.currentProgressState.satisfied = false;
        this.currentProgressState.message = null;
        this.onProgressChange();
    };
    return ProgressManager;
}());
export default ProgressManager;
